export default __webpack_public_path__ + "static/media/product15.418c463b.png";